import { ProfileRole, useProfile } from "@brg/auth";
import { COMPETITIONS_ADD_TABS } from "_competition/pages/AllCompetitionsPage/const/competitionAddTabs";
import { COMPETITIONS_CONTEXTS, getMediiiaCompetitionContext } from "_competition/pages/AllCompetitionsPage/const/competitionContexts";
import { getHsespaceCompetitionContext } from "_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts";
import { getPathContext } from "core/helpers/getPathContext";
import { useMemo } from "react"
import { slashPathIndex } from "shared/constants/enginePaths";
import { HsePolicies } from "shared/constants/HsePolicies";
import { AppTester } from "supporting";

const removeMediiia = (str: string) => {
  return str.replace(/mediiia/gi, '');
}

export const useCompetitionContexts = () => {
    const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
    const isAcademy = AppTester.isAcademy();
    const isDeziiign = AppTester.isCompetition() && !AppTester.isMediiia();
    const isDafes = AppTester.isGeoDafes();
    const isMediiia = AppTester.isMediiia();
    const isCGrave = AppTester.isCGRAVE();
    const isGreenAward = AppTester.isGreenAward();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isPortfolio365 = AppTester.isPortfolio365();
    const isKiiidsArt = AppTester.isKiiidsArt()
    const isMediiiaSport = AppTester.isMediiiaSport();
    const isMediiiaUrban = AppTester.isMediiiaUrban();
    const isBrnd = AppTester.isBrnd();
    const isBooksGallllery = AppTester.isBooksGallllery();
    const isLectureMediiia = AppTester.isLectureMediiia();
    const profile = useProfile();
    const isHseCreative = AppTester.isCreativeHSE()
    const isGame = AppTester.isGameDeziiign();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const isLabDeziiign = AppTester.isLabDeziiign();
    const isHseSpace = AppTester.isHseSpace() 

    const isArtMediiia = AppTester.isArtMediiia() 
    const isPhotoMediiia = AppTester.isMediiiaPhoto()
    const isBooksGalllleryMediiia = AppTester.isBooksMediiia()
    const isCineMediiia = AppTester.isMediiiaCine()
    const isAiMediiia = AppTester.isMediiiaAi()
    const isHistoryMediiia = AppTester.isHistoryMediiia()
    const isStoriesMediiia = AppTester.isMediiiaStories()
    const isAutoMediiia = AppTester.isMediiiaAuto()
    const isSoundMediiia = AppTester.isMusicMediiia()
    const isFoodMediiia = AppTester.isMediiiaFood()
    const isProfMediiia = AppTester.isMediiiaProf()
    const isAstroMediiia = AppTester.isMediiiaNature()
    const isEducationMediiia = AppTester.isLectureMediiia()
    const isConceptMediiia = AppTester.isMediiiaConcept()
    const isEvent = AppTester.isContext('eventmediiia');


    const isEmployee = profile?.globalTypes?.includes('Employee');
    const isCooperator = profile?.globalTypes?.includes('Cooperator');
    const isStudent = profile?.globalTypes?.includes('Student');

    
    const canViewVisualResearch = profile && profile.rolesList && Array.isArray(profile.rolesList)
      && (new ProfileRole(HsePolicies.view_visual_research_ctx)).containsIn(profile.rolesList);

    const shouldDisplayVisualResearch = isEmployee || isCooperator || isStudent || canViewVisualResearch
    
    const {application, mode: env} = getPathContext();
    
    const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
        const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
        const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
        let name = ''
        if (!!splittedCtx) {
            name = removeMediiia(splittedCtx);
        }
        return { has, name }
    }, [application]);
    
    const requestContexts = useMemo(() => (
        isMediaContext && mediaContextName && !isMediiiaUrban ? [
          getMediiiaCompetitionContext(mediaContextName),
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] : 
        isHseSpace ? getHsespaceCompetitionContext(application):
        isLabDeziiign ? [
          COMPETITIONS_CONTEXTS.ldAwards,
          COMPETITIONS_CONTEXTS.concept
        ] :
        isLectureMediiia ? [
          COMPETITIONS_CONTEXTS.educationmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isGame ? [
          COMPETITIONS_CONTEXTS.gdawards,
          COMPETITIONS_CONTEXTS.concept, 
          COMPETITIONS_CONTEXTS.partners_deziiign
        ] :
        isFashionDeziiign ? [
          COMPETITIONS_CONTEXTS.fdawards,
          COMPETITIONS_CONTEXTS.concept, 
          COMPETITIONS_CONTEXTS.partners_deziiign
        ] :
        isDeziiign ? [
          COMPETITIONS_CONTEXTS.concept, 
          COMPETITIONS_CONTEXTS.partners_deziiign, 
          COMPETITIONS_CONTEXTS.openCallsDeziiign,
          COMPETITIONS_CONTEXTS.ratings,
          COMPETITIONS_CONTEXTS.briefs,
        ] :
        isMediiiaSport ? [
          COMPETITIONS_CONTEXTS.sportmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] 
        :
        isGreenAward ? [
          COMPETITIONS_CONTEXTS.greenaward,
          COMPETITIONS_CONTEXTS.lastgreenaward
        ] :
        isAdcrDafesNet ? [
          COMPETITIONS_CONTEXTS.adcrawards,
        ] :
        isBrnd ? [
          COMPETITIONS_CONTEXTS.brndawards,
        ] :
        isMediiiaUrban? [
          COMPETITIONS_CONTEXTS.udawards,
          COMPETITIONS_CONTEXTS.concept,
          COMPETITIONS_CONTEXTS.partners_deziiign
        ] :
        isPhotoMediiia ? [
          COMPETITIONS_CONTEXTS.photomediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isCineMediiia ? [
          COMPETITIONS_CONTEXTS.cinemediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isAiMediiia ? [
          COMPETITIONS_CONTEXTS.aimediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isHistoryMediiia ? [
          COMPETITIONS_CONTEXTS.historymediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isStoriesMediiia ? [
          COMPETITIONS_CONTEXTS.storiesmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isAutoMediiia ? [
          COMPETITIONS_CONTEXTS.automediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isSoundMediiia ? [
          COMPETITIONS_CONTEXTS.musicmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isFoodMediiia ? [
          COMPETITIONS_CONTEXTS.foodmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isProfMediiia ? [
          COMPETITIONS_CONTEXTS.profmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isAstroMediiia ? [
          COMPETITIONS_CONTEXTS.eventmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isConceptMediiia ? [
          COMPETITIONS_CONTEXTS.conceptmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isArtMediiia ? [
          COMPETITIONS_CONTEXTS.artmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isEvent ? [
          COMPETITIONS_CONTEXTS.sportmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isMediiia ? [
          COMPETITIONS_CONTEXTS.mediiiaawards,
          COMPETITIONS_CONTEXTS.dafesawards,
          COMPETITIONS_CONTEXTS.partners_mediiia,
          COMPETITIONS_CONTEXTS.allcontests
        ] :
        isPortfolio365 ? [
          COMPETITIONS_CONTEXTS.main_portfolio,
        ] :
        isBooksGallllery ? [
          COMPETITIONS_CONTEXTS.booksmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isKiiidsArt ? [
          COMPETITIONS_CONTEXTS.kiiids_awards,
        ] :
        isHseCreative ? [
          COMPETITIONS_CONTEXTS.hsecreativeawards,
          COMPETITIONS_CONTEXTS.partners_hse,
          COMPETITIONS_CONTEXTS.openCalls,
        ] :
        isHse ? [
          COMPETITIONS_CONTEXTS.main_hse,
          COMPETITIONS_CONTEXTS.partners_hse,
          COMPETITIONS_CONTEXTS.openCalls,
          COMPETITIONS_CONTEXTS.briefs,
          ...(shouldDisplayVisualResearch ? [
            COMPETITIONS_CONTEXTS.hsevisualresearch] : 
          [])] :
        isAcademy ? [
          COMPETITIONS_CONTEXTS.citycompetitions,
          COMPETITIONS_CONTEXTS.partners_creativecity,
          COMPETITIONS_CONTEXTS.briefs,
        ] :
        isDafes ? [
          COMPETITIONS_CONTEXTS.edu_design, 
          COMPETITIONS_CONTEXTS.edu_art, 
          COMPETITIONS_CONTEXTS.edu_fashion, 
          COMPETITIONS_CONTEXTS.edu_events,
          COMPETITIONS_CONTEXTS.edu_startups,
          COMPETITIONS_CONTEXTS.edu_dafes,
        ] :
        isCGrave ? [
          COMPETITIONS_ADD_TABS.cgwave,
        ]: []
      ), [isDeziiign, isMediaContext, mediaContextName, isHse, isAcademy, isDafes, isMediiia, isPortfolio365, shouldDisplayVisualResearch]);
      
    return requestContexts
}import { ProfileRole, useProfile } from "@brg/auth";
import { COMPETITIONS_ADD_TABS } from "_competition/pages/AllCompetitionsPage/const/competitionAddTabs";
import { COMPETITIONS_CONTEXTS, getMediiiaCompetitionContext } from "_competition/pages/AllCompetitionsPage/const/competitionContexts";
import { getHsespaceCompetitionContext } from "_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts";
import { getPathContext } from "core/helpers/getPathContext";
import { useMemo } from "react"
import { slashPathIndex } from "shared/constants/enginePaths";
import { HsePolicies } from "shared/constants/HsePolicies";
import { AppTester } from "supporting";

const removeMediiia = (str: string) => {
  return str.replace(/mediiia/gi, '');
}

export const useCompetitionContexts = () => {
    const isHse = AppTester.isHSEDesign() || AppTester.isSchool();
    const isAcademy = AppTester.isAcademy();
    const isDeziiign = AppTester.isCompetition() && !AppTester.isMediiia();
    const isDafes = AppTester.isGeoDafes();
    const isMediiia = AppTester.isMediiia();
    const isCGrave = AppTester.isCGRAVE();
    const isGreenAward = AppTester.isGreenAward();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isPortfolio365 = AppTester.isPortfolio365();
    const isKiiidsArt = AppTester.isKiiidsArt()
    const isMediiiaSport = AppTester.isMediiiaSport();
    const isMediiiaUrban = AppTester.isMediiiaUrban();
    const isBrnd = AppTester.isBrnd();
    const isBooksGallllery = AppTester.isBooksGallllery();
    const isLectureMediiia = AppTester.isLectureMediiia();
    const profile = useProfile();
    const isHseCreative = AppTester.isCreativeHSE()
    const isGame = AppTester.isGameDeziiign();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const isLabDeziiign = AppTester.isLabDeziiign();
    const isHseSpace = AppTester.isHseSpace() 

    const isArtMediiia = AppTester.isArtMediiia() 
    const isPhotoMediiia = AppTester.isMediiiaPhoto()
    const isBooksGalllleryMediiia = AppTester.isBooksMediiia()
    const isCineMediiia = AppTester.isMediiiaCine()
    const isAiMediiia = AppTester.isMediiiaAi()
    const isHistoryMediiia = AppTester.isHistoryMediiia()
    const isStoriesMediiia = AppTester.isMediiiaStories()
    const isAutoMediiia = AppTester.isMediiiaAuto()
    const isSoundMediiia = AppTester.isMusicMediiia()
    const isFoodMediiia = AppTester.isMediiiaFood()
    const isProfMediiia = AppTester.isMediiiaProf()
    const isAstroMediiia = AppTester.isMediiiaNature()
    const isEducationMediiia = AppTester.isLectureMediiia()
    const isConceptMediiia = AppTester.isMediiiaConcept()
    const isEvent = AppTester.isContext('eventmediiia');


    const isEmployee = profile?.globalTypes?.includes('Employee');
    const isCooperator = profile?.globalTypes?.includes('Cooperator');
    const isStudent = profile?.globalTypes?.includes('Student');

    
    const canViewVisualResearch = profile && profile.rolesList && Array.isArray(profile.rolesList)
      && (new ProfileRole(HsePolicies.view_visual_research_ctx)).containsIn(profile.rolesList);

    const shouldDisplayVisualResearch = isEmployee || isCooperator || isStudent || canViewVisualResearch
    
    const {application, mode: env} = getPathContext();
    
    const { has: isMediaContext, name: mediaContextName } = useMemo(() => {
        const has = !!Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application);
        const splittedCtx = Object.values(slashPathIndex['deziiign/mediiia'])?.find((i) => i === application)?.split('/')?.[1];
        let name = ''
        if (!!splittedCtx) {
            name = removeMediiia(splittedCtx);
        }
        return { has, name }
    }, [application]);
    
    const requestContexts = useMemo(() => (
        isMediaContext && mediaContextName && !isMediiiaUrban ? [
          getMediiiaCompetitionContext(mediaContextName),
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] : 
        isHseSpace ? getHsespaceCompetitionContext(application):
        isLabDeziiign ? [
          COMPETITIONS_CONTEXTS.ldAwards,
          COMPETITIONS_CONTEXTS.concept
        ] :
        isLectureMediiia ? [
          COMPETITIONS_CONTEXTS.educationmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isGame ? [
          COMPETITIONS_CONTEXTS.gdawards,
          COMPETITIONS_CONTEXTS.concept, 
          COMPETITIONS_CONTEXTS.partners_deziiign
        ] :
        isFashionDeziiign ? [
          COMPETITIONS_CONTEXTS.fdawards,
          COMPETITIONS_CONTEXTS.concept, 
          COMPETITIONS_CONTEXTS.partners_deziiign
        ] :
        isDeziiign ? [
          COMPETITIONS_CONTEXTS.concept, 
          COMPETITIONS_CONTEXTS.partners_deziiign, 
          COMPETITIONS_CONTEXTS.openCallsDeziiign,
          COMPETITIONS_CONTEXTS.ratings,
          COMPETITIONS_CONTEXTS.briefs,
        ] :
        isMediiiaSport ? [
          COMPETITIONS_CONTEXTS.sportmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] 
        :
        isGreenAward ? [
          COMPETITIONS_CONTEXTS.greenaward,
          COMPETITIONS_CONTEXTS.lastgreenaward
        ] :
        isAdcrDafesNet ? [
          COMPETITIONS_CONTEXTS.adcrawards,
        ] :
        isBrnd ? [
          COMPETITIONS_CONTEXTS.brndawards,
        ] :
        isMediiiaUrban? [
          COMPETITIONS_CONTEXTS.udawards,
          COMPETITIONS_CONTEXTS.concept,
          COMPETITIONS_CONTEXTS.partners_deziiign
        ] :
        isPhotoMediiia ? [
          COMPETITIONS_CONTEXTS.photomediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isCineMediiia ? [
          COMPETITIONS_CONTEXTS.cinemediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isAiMediiia ? [
          COMPETITIONS_CONTEXTS.aimediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isHistoryMediiia ? [
          COMPETITIONS_CONTEXTS.historymediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isStoriesMediiia ? [
          COMPETITIONS_CONTEXTS.storiesmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isAutoMediiia ? [
          COMPETITIONS_CONTEXTS.automediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isSoundMediiia ? [
          COMPETITIONS_CONTEXTS.musicmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isFoodMediiia ? [
          COMPETITIONS_CONTEXTS.foodmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isProfMediiia ? [
          COMPETITIONS_CONTEXTS.profmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isAstroMediiia ? [
          COMPETITIONS_CONTEXTS.eventmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isConceptMediiia ? [
          COMPETITIONS_CONTEXTS.conceptmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isArtMediiia ? [
          COMPETITIONS_CONTEXTS.artmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isEvent ? [
          COMPETITIONS_CONTEXTS.sportmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isMediiia ? [
          COMPETITIONS_CONTEXTS.mediiiaawards,
          COMPETITIONS_CONTEXTS.dafesawards,
          COMPETITIONS_CONTEXTS.partners_mediiia,
          COMPETITIONS_CONTEXTS.allcontests
        ] :
        isPortfolio365 ? [
          COMPETITIONS_CONTEXTS.main_portfolio,
        ] :
        isBooksGallllery ? [
          COMPETITIONS_CONTEXTS.booksmediiiawards,
          COMPETITIONS_CONTEXTS.mediiiaawards
        ] :
        isKiiidsArt ? [
          COMPETITIONS_CONTEXTS.kiiids_awards,
        ] :
        isHseCreative ? [
          COMPETITIONS_CONTEXTS.hsecreativeawards,
          COMPETITIONS_CONTEXTS.partners_hse,
          COMPETITIONS_CONTEXTS.openCalls,
        ] :
        isHse ? [
          COMPETITIONS_CONTEXTS.main_hse,
          COMPETITIONS_CONTEXTS.partners_hse,
          COMPETITIONS_CONTEXTS.openCalls,
          COMPETITIONS_CONTEXTS.briefs,
          ...(shouldDisplayVisualResearch ? [
            COMPETITIONS_CONTEXTS.hsevisualresearch] : 
          [])] :
        isAcademy ? [
          COMPETITIONS_CONTEXTS.citycompetitions,
          COMPETITIONS_CONTEXTS.partners_creativecity,
          COMPETITIONS_CONTEXTS.briefs,
        ] :
        isDafes ? [
          COMPETITIONS_CONTEXTS.edu_design, 
          COMPETITIONS_CONTEXTS.edu_art, 
          COMPETITIONS_CONTEXTS.edu_fashion, 
          COMPETITIONS_CONTEXTS.edu_events,
          COMPETITIONS_CONTEXTS.edu_startups,
          COMPETITIONS_CONTEXTS.edu_dafes,
        ] :
        isCGrave ? [
          COMPETITIONS_ADD_TABS.cgwave,
        ]: []
      ), [isDeziiign, isMediaContext, mediaContextName, isHse, isAcademy, isDafes, isMediiia, isPortfolio365, shouldDisplayVisualResearch]);
      
    return requestContexts
}